export default "__VITE_ASSET___raMkN$T__"